import React from "react"
import I18n from "@helper/i18nInstance"

import "./Cover.scss"
import { useQuiz } from "@Quiz/context"
import ContainedImg from "@Quiz/Ui/ContainedImg"
import Button from "@ui/Button"

const Cover: React.FC = () => {
  const { quiz, actions } = useQuiz()
  if (!quiz?.cover) { return null }

  return (
    <div className="neo__quizCover" data-testid="quiz-cover">
      <div className="neo__quizCover__titlesHolder">
        <h3>{quiz.cover.subtitle || " "}</h3>
        <h2>{quiz.meta.title}</h2>
      </div>
      {quiz.cover.image &&
        <div className="neo__quizCover__imgWithCreditsHolder">
          <ContainedImg className="neo__quizCover__img" src={quiz.cover.image["1x"]} testId="quiz-cover-image" />
          {quiz.cover.image_credit && <div className="neo__quizCover__imgCredit">{quiz.cover.image_credit}</div>}
        </div>}
      <Button onClick={() => actions.startQuiz()}>{I18n.t("quiz.actions.start")}</Button>
    </div>
  )
}

export default Cover
